var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82983 0.753906C9.2765 0.753906 9.64316 1.10474 9.66316 1.55057L9.95733 8.32724C9.97733 8.78724 9.62066 9.17641 9.16066 9.19641C8.70066 9.21641 8.31233 8.85974 8.29233 8.39974L8.079 3.51641L1.759 9.83641C1.434 10.1614 0.905664 10.1614 0.580664 9.83641C0.255664 9.51141 0.255664 8.98391 0.580664 8.65807L6.81816 2.42057H1.75816C1.29816 2.42057 0.924831 2.04724 0.924831 1.58724C0.924831 1.12724 1.29816 0.753906 1.75816 0.753906H8.829H8.82983Z",
    fill: "#246A18"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUpArrow);
export default __webpack_public_path__ + "static/media/graph_up_arrow.2a8ace086005918010f16debe604bdfb.svg";
export { ForwardRef as ReactComponent };